export default "__VITE_ASSET__Br8ys1ns__"